import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { PreloadingStrategy, Route } from '@angular/router';
import { Logger } from '../services/logger/logger.service';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  constructor(private logger: Logger, private authService: AuthService) {}
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload'] && route.data['preload'] == true) {
      this.logger.trace('[CustomPreloadingStrategy] - preload');
      return load();
    }

    if (
      route.data &&
      route.data['preloadDelay'] &&
      Number.isFinite(parseInt(route.data['preloadDelay'], 10))
    ) {
      this.logger.trace('[CustomPreloadingStrategy] - preloadDelay: ', route.data['preloadDelay']);
      return timer(parseInt(route.data['preloadDelay'], 10)).pipe(
        mergeMap((_) => {
          return load();
        })
      );
    }

    const isLoggedIn = this.authService.isAuthenticated();
    this.logger.trace('[CustomPreloadingStrategy] - isLoggedIn: ', isLoggedIn);
    if (
      (isLoggedIn && route.data && route.data['isAuthRoute']) ||
      (!isLoggedIn && (!route.data || !route.data['isAuthRoute']))
    ) {
      this.logger.trace(
        '[CustomPreloadingStrategy] - isAuthRoute: ',
        route.data && route.data['isAuthRoute']
      );
      return timer(2000).pipe(
        mergeMap((_) => {
          return load();
        })
      );
    }

    this.logger.trace('[CustomPreloadingStrategy] - default: ', 1000);

    return timer(1000).pipe(
      mergeMap((_) => {
        return load();
      })
    );
  }
}
